/**
 * @generated SignedSource<<fa35ae5073a093934cc8bcd48157fe57>>
 * @relayHash 3cb7419e83ef24d2a43af6010f8ec711
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c892f61b3534b142463458eb41054d4a2186bf40bb585923c90e681fb010ce6

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useContextualEmojiUserPreferencesMutation$variables = {
  contextualEmojiOptOut: boolean;
};
export type useContextualEmojiUserPreferencesMutation$data = {
  readonly updateUserPreferences: {
    readonly __typename: "UserPreferences";
    readonly contextualEmojiOptOut: boolean | null | undefined;
  } | null | undefined;
};
export type useContextualEmojiUserPreferencesMutation = {
  response: useContextualEmojiUserPreferencesMutation$data;
  variables: useContextualEmojiUserPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextualEmojiOptOut"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contextualEmojiOptOut",
            "variableName": "contextualEmojiOptOut"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contextualEmojiOptOut"
      },
      {
        "kind": "ScalarField",
        "name": "__typename"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContextualEmojiUserPreferencesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContextualEmojiUserPreferencesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3cb7419e83ef24d2a43af6010f8ec711",
    "id": "6c892f61b3534b142463458eb41054d4a2186bf40bb585923c90e681fb010ce6",
    "metadata": {},
    "name": "useContextualEmojiUserPreferencesMutation",
    "operationKind": "mutation",
    "text": "mutation useContextualEmojiUserPreferencesMutation($contextualEmojiOptOut:Boolean!){updateUserPreferences(userPreferences:{contextualEmojiOptOut:$contextualEmojiOptOut}){contextualEmojiOptOut,__typename}}"
  }
};
})();

(node as any).hash = "3463b6db37ef39ac20520559ae206c44";

export default node;
